module.exports = __webpack_public_path__ + "static/media/garderobe_active_start.a520271a.jpg";